import { useCurrentUser } from '@/auth/useCurrentUser';

import { COMPANY_ROOT_PATH } from '@/lib/constants';

import { IconMenuItem } from './IconMenuItem';

const DoctorAppIconMenuItem = () => {
  const currentUser = useCurrentUser();
  const { doctorId, membershipsCount } = currentUser;

  const showDoctorApp = Boolean(doctorId || membershipsCount);
  if (!showDoctorApp) return null;

  return (
    <IconMenuItem
      icon="user-doctor"
      href={COMPANY_ROOT_PATH}
      label="Doctor App"
    />
  );
};

export default DoctorAppIconMenuItem;
